import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button, MenuItem } from 'react-bootstrap'
import MEModal from '../../components/MEModal'
import { VideoChapter } from './VideoChapter'
import { forceVideoAnalytics } from '../actions'
import { connect } from 'react-redux'
import ButterToast, { Cinnamon } from 'butter-toast'

class ForceVideoModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      forceVideoModalOpen: false,
      videos: [],
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.submitAnalytics = this.submitAnalytics.bind(this)
  }

  toggleModal = () => {
    this.setState({
      forceVideoModalOpen: !this.state.forceVideoModalOpen,
    })
    return
  }

  handleChange = e => {
    if (this.state.videos.includes(e.target.value)) {
      this.setState({
        videos: this.state.videos.filter(vid => vid !== e.target.value),
      })
    } else {
      this.setState({
        videos: [...this.state.videos, e.target.value],
      })
    }
  }

  async submitAnalytics() {
    let cmVids = {
      cmId: this.props.user_id,
      videos: this.state.videos,
    }
    let resp = await this.props.forceVideoAnalytics(cmVids)
    this.toggleModal()

    if (resp.status === 204) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Analytics Updated"
            content={`Successfully forced analytics for ${this.props.user_full_name}.`}
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      let error = resp.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error trying to force analytics. ${error}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem onClick={this.toggleModal} className="me-list-item">
          <i className="fal fa-video fa-fw mr-2 color_teal" /> Force Video
        </MenuItem>
        <MEModal
          show={this.state.forceVideoModalOpen}
          close={this.toggleModal}
          title="Record Video Completion"
        >
          <div>
            {this.props.videoData.map(chapter => (
              <VideoChapter
                chapter={chapter}
                key={chapter[0]}
                handleChange={this.handleChange}
              />
            ))}
            <div className="text-center">
              <Button
                className="mt-5 mx-auto btn-myed btn-primary-myed"
                type="button"
                bsStyle="primary"
                onClick={this.submitAnalytics}
              >
                Submit
              </Button>
            </div>
          </div>
        </MEModal>
      </Fragment>
    )
  }
}

ForceVideoModal.propTypes = {
  videoData: PropTypes.array,
  forceVideoAnalytics: PropTypes.func,
  user_id: PropTypes.string,
  user_full_name: PropTypes.string,
}

const mapDispatchToProps = dispatch => {
  return {
    forceVideoAnalytics: videos => dispatch(forceVideoAnalytics(videos)),
  }
}

export default connect(null, mapDispatchToProps)(ForceVideoModal)
